import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const LanguageIcon: FC<Props> = (props) => {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="language icon">
      {/* <title>language icon</title> */}
      <path
        d="M9.08312 3.76562H17.5178C20.4659 3.76562 22.3 5.84681 22.3 8.792V16.7392C22.3 19.6844 20.4659 21.7656 17.5169 21.7656H9.08312C6.13502 21.7656 4.29999 19.6844 4.29999 16.7392V8.792C4.29999 5.84681 6.14377 3.76562 9.08312 3.76562Z"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9387 15.75C14.6684 16.0419 15.0907 16.0837 15.9274 16.0837C16.4139 16.0837 17.0989 15.8638 17.5562 15.7665"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3078 16.9891L15.7568 12.1914L18.2067 16.9891"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1086 11.3359C10.3411 12.2914 10.7867 13.1612 11.3871 13.891C11.5934 14.1391 11.8201 14.3726 12.0623 14.5896"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7151 9.41016C13.7734 9.53275 13.4747 13.8557 8.69354 15.319"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.39374 9.41016H15.3427"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6887 8.54297V9.40794"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LanguageIcon;
